import React from 'react';
import {Dialog} from '@mui/material';
import {useSearchParams} from 'react-router';
import DocumentView from './DocumentView';

// When rendered inside the report page, portal into the content area so the
// Dialog is constrained by Shell's marginRight (which shrinks when
// CommunicationHub opens).  Falls back to document.body on other pages.
function getReportContentContainer() {
    return document.getElementById('report-content-area') || document.body;
}

const EvidenceModal = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const documentId = searchParams.get('documentId');
    const isBuilder = searchParams.get('isBuilderOpen') === 'true';

    const open = !!documentId && !isBuilder;

    function handleClose() {
        setSearchParams(prev => {
            const sp = new URLSearchParams(prev);
            sp.delete('documentId');
            sp.delete('segmentIndex');
            return sp;
        });
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={'md'}
            id={'evidence-modal'}
            container={getReportContentContainer}
            sx={{position: 'absolute'}}
            slotProps={{
                paper: {className: 'evidence-allow-select'},
                backdrop: {sx: {position: 'absolute'}},
            }}
        >
            {open ? <DocumentView/> : null}
        </Dialog>
    );
};

export default EvidenceModal;
